import Repository from '@/api/core'
import queryString from 'query-string'
import vendor from '@/store/modules/vendor'
const baseURL = process.env.VUE_APP_API_MEMBERSHIP + '/membership'
const baseURLUserMembership = process.env.VUE_APP_API_MEMBERSHIP + '/user-membership'

const fetch = (params) => {
  const query = queryString.stringify({
    ...params,
    vendorId: vendor.state.vendor.vendorId,
  })
  return Repository(baseURL + `?${query}`).fetch()
}

const fetchOne = (id) => {
  return Repository(baseURL).fetchOne(id)
}

const fetchMembershipsByUserId = (id) => {
  return Repository(baseURLUserMembership).fetchOne(id)
}

export default {
  fetch,
  fetchOne,
  fetchMembershipsByUserId,
}
